<template>
  <!-- CPAP 転院情報詳細 -->
  <div id="CpapHospitalTransfer">
    <div :id="getContainerType()">
      <div class="labelTitle lable">CPAP 転院申込み</div>
      <div class="button-area"><b-button class="backButton is-primary" @click="back">戻る</b-button></div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <table>
            <tr>
              <th>転院予定月<span class="require"/></th>
              <td>
                <input type="month" v-model="data.transferDate" class="1" name="転院予定月" validate="required|month" style="width:150px;"/>
              </td>
            </tr>
            <tr>
              <th>転院先</th>
              <td><div>
                <b-radio class="td_radio" name="transferDestination" v-model="transferDestination" :native-value="true">指定</b-radio>
                <b-radio class="td_radio" name="transferDestination" v-model="transferDestination" :native-value="false">未定</b-radio>
              </div></td>
            </tr>
            <template v-if="transferDestination">
              <tr><th/><td>※転院先を指定される場合は、転院先医療機関から医療機関を選択してください。<br>&emsp;転院先医療機関にない施設を希望される場合は、医療機関名と医療機関住所（都道府県・市区町村）を直接入力してください。</td></tr>
              <tr>
                <th>転院先医療機関</th>
                <td>
                  <input type="text" style="width:730px;" name="医療機関名" disabled v-model="data.transferDestinationName"/>
                  <b-button style="margin-left:10px; width:150px; height:27px;" @click="organizationModalActive=true">医療機関選択</b-button>
                </td>
              </tr>
              <!-- フリー入力欄 -->
              <!-- 転院先医療機関にない施設を希望される場合は、「医療機関名」を入力してください。
              転院先医療機関にない施設を希望される場合は、「医療機関住所」を入力してください。 -->
              <tr>
                <th>医療機関名</th>
                <td><input type="text" style="width:730px;" name="医療機関名" v-model="data.transferDestinationNameFree" placeholder="転院先医療機関にない施設を希望される場合は、「医療機関名」を入力してください。"/></td>
              </tr>
              <tr>
                <th>医療機関住所</th>
                <td><input type="text" style="width:730px;" name="医療機関住所" v-model="data.transferDestinationAddress" placeholder="転院先医療機関にない施設を希望される場合は、「医療機関住所」を入力してください。"/></td>
              </tr>
            </template>
            <tr>
              <th style="vertical-align:top;">申送り事項</th>
              <td>
                <textarea maxlength="256" style="resize:vertical;max-width:97%;height:100px;" v-model="data.transferMemo"></textarea>
              </td>
            </tr>
          </table>
        </div>
        <div class="button-area">
          <b-button class="is-primary" v-if="undecidedFlg" v-on:click="hospitalDecision" :disabled="!data.transferDestinationName">転院先決定</b-button>
          <b-button class="is-primary" v-else @click="changeHospital">申込む</b-button>
        </div>
        <div class="card-content margin-top">
          <span style="font-size:20px;">患者情報</span>
          <table>
            <tr>
              <th>患者コード</th>
              <td>{{data.patientCode}}</td>
            </tr>
            <tr>
              <th>患者名</th>
              <td>{{data.patientName}}</td>
            </tr>
            <tr>
              <th>住所</th>
              <td>{{data.patient.address}}</td>
            </tr>
            <tr>
              <th>電話番号</th>
              <td>{{data.patient.phoneNumber}}</td>
            </tr>
            <tr>
              <th>携帯電話</th>
              <td>{{data.patient.mobilePhone}}</td>
            </tr>
            <tr>
              <th>誕生日</th>
              <td>{{convertDate(data.patient.birthday)}}</td>
            </tr>
            <tr>
              <th>年齢</th>
              <td>{{data.patient.age}}</td>
            </tr>
            <tr>
              <th>性別</th>
              <td>{{data.patient.gender}}</td>
            </tr>
            <tr>
              <th>転院元医療機関</th>
              <td>{{data.medicalInstitutionName}}</td>
            </tr>
            <tr v-if="isHonsha || isAdmin || isSalesOffice">
              <th>コメント</th>
              <td>{{data.note}}</td>
            </tr>
          </table>
        </div>
        <div class="button-area">
          <b-button v-if="data.changeHospital" class="is-primary" style="margin-left:10%;" @click="cancelReasonInputModalActive=true">キャンセル</b-button>
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
    </div>
    <b-modal :active.sync="organizationModalActive" has-modal-card>
      <organizationSelectModal :selectRole="[role.role_hospital]" :selectStatus="extUserStatus.registed" title="医療機関選択" labelForOrg="医療機関名" @select="setHospital" :exclusionId="data.belongsId" :agreedInfoDisclosure="isHospital || isDealer" :transferFlg="true"></organizationSelectModal>
    </b-modal>
    <b-modal :active.sync="cancelReasonInputModalActive" has-modal-card>
      <reasonInputModal  v-on:setReason="cancel" v-bind:title="'キャンセル理由入力'"></reasonInputModal>
    </b-modal>
  </div>
</template>
<script>
import {role} from "@/components/mock/base/const.js";
import {extUserStatus} from "@/components/mock/base/const.js";
import OrganizationSelectModal from "@/components/mock/philips/common/OrganizationSelectModal";
import reasonInputModal from "@/components/mock/philips/common/reasonInputModal";

export default {
  name: "CpapHospitalTransfer",
  methods: {
    getContainerType: function(){
      let type = "container";
      if(this.isHospital || this.isDealer){
        type = "container-center"
      }
      return type;
    },
    back: function() {
      if (this.isHospital || this.isDealer) {
        this.$router.push({ 
          name: "CpapPatientDetail",
          params: { targetId:this.searchId, searchConditions: this.searchParams, isEscrow: this.isEscrow},
        });
      }else{
        this.$router.push({ 
          name: "CpapAgentPatientDetail",
          params: { targetId:this.searchId, searchConditions: this.searchParams, isEscrow: this.isEscrow},
        });
      }
    },
    convertDate: function(day){
      return day ? day.replace(/-/g, "/") : ""
    },
    changeHospital: function() {
      var elements = document.getElementsByClassName(1)
      var result = this.selfMadeValidation(elements)
      if(result.isError){
        this.showErrorMessage(result.msg)
        return
      }
      if(this.transferDestination && !this.data.transferDestinationName && (!this.data.transferDestinationNameFree || !this.data.transferDestinationAddress)){
        this.showErrorMessage("転院先医療機関を選択もしくは、<br/>「医療機関名」「医療機関住所」を入力してください。")
        return
      }
      this.$dialog.confirm({
        title: "申込み確認",
        message: "転院を申込みます。<br/>内容が正しいことを確認して「OK」ボタンを押してください。",
        cancelText: "修正する",
        onConfirm: async () => {
          this.compleateFlg = false;
          var excuteApi = this.setCpapTransferRequestPOST;
          var successCallBack = this.setCpapTransferRequestPOSTSuccess;
          var errorCallBack = this.setCpapTransferRequestPOSTError;
          // WebAPI Call
          await this.apiCall(excuteApi, successCallBack, errorCallBack)
          if(this.compleateFlg){
            this.back()
          }
        }
      });
    },
    setCpapTransferRequestPOST: function(client) {
      return client.apis.externalCpap.setCpapTransferRequestPOST({
        body:{
          id:this.searchId,
          transferDate:this.data.transferDate ? this.data.transferDate.replace(/-/g, "/") :"",
          transferDestinationId:this.data.transferDestinationId,
          transferInstitutionId:this.data.transferInstitutionId,
          transferDestinationCode:this.data.transferDestinationCode,
          transferDestinationName:this.data.transferDestinationName,
          transferDestinationNameFree:this.data.transferDestinationNameFree,
          transferDestinationAddress:this.data.transferDestinationAddress,
          transferMemo:this.data.transferMemo,
          role : this.data.role,//ディーラー配下施設転院
          temp:this.temp
        }
      });
    },
    setCpapTransferRequestPOSTSuccess: function(result) {
      this.showSuccess(result);
      this.compleateFlg = true;
    },
    setCpapTransferRequestPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    cancel: function(cancelReason) {
      // キャンセル
      this.reason = cancelReason
      var excuteApi = this.setCpapRequestCancelPOST;
      var successCallBack = this.setCpapRequestCancelPOSTSuccess;
      var errorCallBack = this.setCpapRequestCancelPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setCpapRequestCancelPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.data));
      obj.reason = this.reason
      return client.apis.internalCpap.setCpapRequestCancelPOST({
        body:obj
      });
    },
    setCpapRequestCancelPOSTSuccess: function(result) {
      this.showSuccess(result);
      this.back();
    },
    setCpapRequestCancelPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    setHospital: function(hospitalInfo){
      this.data.transferDestinationId = hospitalInfo.id
      this.data.transferInstitutionId = hospitalInfo.sstId//ディーラー配下施設転院
      this.data.transferDestinationCode = hospitalInfo.customerCode
      this.data.transferDestinationName = hospitalInfo.orgName
      this.data.role = hospitalInfo.role//ディーラー配下施設転院
    },
    hospitalDecision: function(){
      // 転院先設定
      var excuteApi = this.setCpapTransferDestinationPOST;
      var successCallBack = this.setCpapTransferDestinationPOSTSuccess;
      var errorCallBack = this.setCpapTransferDestinationPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setCpapTransferDestinationPOST: function(client) {
      return client.apis.externalCpap.setCpapTransferDestinationPOST({
        body:{
          receiptNumber:this.data.receiptNumber,
          transferDate:this.data.transferDate ? this.data.transferDate.replace(/-/g, "/") :"",
          transferDestinationId:this.data.transferDestinationId,
          transferInstitutionId:this.data.transferInstitutionId,
          transferDestinationCode:this.data.transferDestinationCode,
          transferDestinationName:this.data.transferDestinationName,
          transferMemo:this.data.transferMemo,
          role:this.data.role,//ディーラー配下施設転院
        }
      });
    },
    setCpapTransferDestinationPOSTSuccess: function(result) {
      this.showSuccess(result);
      this.back();
    },
    setCpapTransferDestinationPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    }
  },
  data() {
    var searchId = this.$route.params["targetId"];
    var searchParams = this.$route.params["searchConditions"];
    var selectedData = {}
    var transferDestination = false
    if(this.$route.params["selectedData"]){
      selectedData = this.$route.params["selectedData"];
      transferDestination = selectedData.transferDestinationName ? true : false
    }
    // 仮持出申込み判定
    var temp = false;
    if(this.$route.params["temp"]){
      temp = this.$route.params["temp"];
    }
    if(!selectedData.transferDate){
      var today = new Date()
      selectedData.transferDate = today.getFullYear() + "-" + (today.getMonth() + 2)
    }else{
      var y = selectedData.transferDate.split("-")[0];
      var m = selectedData.transferDate.split("-")[1];
      selectedData.transferDate = y + "-" + m
    }
    var undecidedFlg = this.$route.params["isApplied"];
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var userId = userInfo.id;
    var isHospital = roleId == role.role_hospital;
    var isDealer = roleId == role.role_dealer;
    var isSalesOffice = roleId == role.role_salesOffice;
    var isHonsha = roleId == role.role_headOffice;
    var isAdmin = roleId == role.role_admin;
    const isEscrow = this.$route.params["isEscrow"]
    return {
      searchId,
      searchParams,
      transferDestination,
      data: selectedData,
      role: role,
      extUserStatus: extUserStatus,
      organizationModalActive: false,
      cancelReasonInputModalActive:false,
      roleId: roleId,
      userId: userId,
      isHospital: isHospital,
      isDealer: isDealer,
      isSalesOffice: isSalesOffice,
      isHonsha: isHonsha,
      isAdmin: isAdmin,
      reason:"",
      compleateFlg:false,
      temp,
      undecidedFlg,
      isEscrow,
    };
  },
  filters: {},
  components: {
    organizationSelectModal:OrganizationSelectModal,
    reasonInputModal:reasonInputModal
  },
  async mounted() {
  },
    watch: {
    "transferDestination"(newValue) {

      this.data.transferDestinationId = null;
      this.data.transferDestinationCode = "";
      this.data.transferDestinationName = "";
      this.data.transferDestinationNameFree = "";
      this.data.transferDestinationAddress = "";

    }
  }
};
</script>
<style lang="scss" scoped>
table.flowTable,
table.flowTable tr,
table.flowTable td {
  border: 1px solid;
  padding: 0px;
  vertical-align: middle;
}
table.flowTable td {
  width: 40px;
  text-align: center;
}
a {
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/cpap/CpapHospitalTransfer.vue